import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { FaArrowRight } from "react-icons/fa";
import bg1 from "../assets/bg1.jpg";
import bg2 from "../assets/bg2.jpg";
import bg3 from "../assets/bg3.jpg";
import bg5 from "../assets/bg5.jpg";
import generalContracting from "../assets/bg3.jpg";
import accessoryBuilding from "../assets/accesory.jpg";
import bathroomRemodeling from "../assets/bathroom.jpg";
import kitchenRemodeling from "../assets/kitchen.jpg";
import basementRemodeling from "../assets/basement.jpg";
import deckConstruction from "../assets/landingafter.jpg";
import painting from "../assets/painting.jpg";
import roofWorks from "../assets/roof.jpg";
import assemblingInstallation from "../assets/assembling.jpg";
import plumbingElectrical from "../assets/lights.jpg";
import homeRepairs from "../assets/homerepair.jpg";


const Services = () => {
  const images = [bg1, bg2, bg3, bg5];
  const [bgImage, setBgImage] = useState(images[0]);
  const [bgIndex, setBgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % images.length;
        setBgImage(images[newIndex]);
        return newIndex;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  return (
    <div className="text-center jost bg-[#7A918D]">
      <motion.div
        className="relative h-96 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-[#000000] bg-opacity-10 flex items-center justify-center flex-col">
          <motion.h1
            className="text-[#fcc11b] text-4xl font-bold mb-4"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            Our Services
          </motion.h1>
          <motion.div
            whileHover={{
              scale: 1.1,
              translateZ: 50,
              perspective: 1000,
              boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
              transition: { duration: 0.2 },
            }}
            className="inline-block mb-4"
          >
            <a
              href="sms:+12065308861?body=Hi,%20I%20am%20interested%20in%20a%20project%20from%20Fixit%20Handyman.%20Project%20Details:"
              className="bg-[#fcc11b] text-[#000000] px-4 py-2 rounded font-bold"
            >
              <span>📞</span>
              <span>(206) 530-8861</span>
            </a>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        className="bg-[#fcc11b] py-10 px-4 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <motion.h2
          className="bg-gradient-to-r to-[#000000] from-[#7A918D] text-transparent bg-clip-text text-3xl font-bold mb-4"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          3 step process to getting your dream home
        </motion.h2>
        <div className="flex flex-col md:flex-row justify-around items-center text-[#000000]">
          <motion.div
            className="mb-4 md:mb-0 flex flex-col items-center"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="bg-[#000000] p-4 rounded-full text-2xl mb-2 text-[#fcc11b]">
              1
            </div>
            <h3 className="text-xl font-semibold mb-1">
              Call,Text or Email us for a free quote
            </h3>
          </motion.div>
          <FaArrowRight className="text-[#000000] text-3xl mx-4 md:inline-block hidden" />
          <motion.div
            className="mb-4 md:mb-0 flex flex-col items-center "
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="bg-[#000000] p-4 rounded-full text-2xl mb-2 text-[#fcc11b]">
              2
            </div>
            <h3 className="text-xl font-semibold mb-1">
              Let us figure out the best solution for you
            </h3>
          </motion.div>
          <FaArrowRight className="text-[#000000] text-3xl mx-4 md:inline-block hidden" />
          <motion.div
            className="flex flex-col items-center"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="bg-[#000000] p-4 rounded-full text-2xl mb-2 text-[#fcc11b]">
              3
            </div>
            <h3 className="text-xl font-semibold mb-1">
              Sit back and relax while we do the work
            </h3>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        className="max-w-4xl mx-auto text-000000 px-4 pt-4 pb-10 "
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pt-4 text-[#fcc11b]">
          <ServiceCard
            title="General Contracting"
            backgroundImage={generalContracting}
          />
          <ServiceCard
            title="Accessory Building Construction"
            backgroundImage={accessoryBuilding}
          />
          <ServiceCard
            title="Bathroom Remodeling"
            backgroundImage={bathroomRemodeling}
          />
          <ServiceCard
            title="Kitchen Remodeling"
            backgroundImage={kitchenRemodeling}
          />
          <ServiceCard
            title="Basement Remodeling"
            backgroundImage={basementRemodeling}
          />
          <ServiceCard
            title="Deck and Outdoor Pergola Construction"
            backgroundImage={deckConstruction}
          />
          <ServiceCard
            title="Exterior and Interior Painting"
            backgroundImage={painting}
          />
          <ServiceCard title="Roof Works" backgroundImage={roofWorks} />
          <ServiceCard
            title="Assembling and Installation"
            backgroundImage={assemblingInstallation}
          />
          <ServiceCard
            title="Plumbing and Electrical Troubleshooting"
            backgroundImage={plumbingElectrical}
          />
          <ServiceCard title="Home Repairs" backgroundImage={homeRepairs} />
        </div>
      </motion.div>
    </div>
  );
};

const ServiceCard = React.forwardRef(
  ({ title, backgroundImage, path }, ref) => {
    const { ref: inViewRef, inView } = useInView({
      triggerOnce: true,
      threshold: 0.2,
    });

    const cardStyle = {
      backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    };

    return (
      <Link to={path} className="block" ref={inViewRef}>
        <motion.div
          className="bg-000000 bg-opacity-25 rounded-md p-4 flex flex-col items-center justify-center text-center hover:bg-opacity-50 transition duration-300 h-40 w-full"
          style={cardStyle}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          whileHover={{
            scale: 1.1,
            translateZ: 50,
            perspective: 1000,
            boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
            transition: { duration: 0.01 },
          }}
        >
          <h2 className="text-3xl font-semibold mb-2 text-[#fcc11b]">
            {title}
          </h2>
        </motion.div>
      </Link>
    );
  }
);

export default Services;
